<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormPerfil" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objPerfil.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="TipoPerfil">TipoPerfil</label>
                            <select v-model="objPerfil.TipoPerfil" class="form-control form-select">
                                <option value="">--Seleccione una opción--</option>
                                <option value="UR" v-show="Ocultar">Usuario Root</option>
                                <option value="US">Personal Sistema</option>
                                <option value="UH">Personal Hotel</option>
                            </select>
							<CValidation v-if="this.errorvalidacion.TipoPerfil" :Mensaje="'*'+errorvalidacion.TipoPerfil[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormPerfil',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objPerfil: {
				IdPerfil: 0,
				Nombre: '',
				isDefault: 0,
				TipoPerfil: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            Ocultar: false,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objPerfil.IdPerfil == 0) {
				await this.$http.post(
					'perfiles',this.objPerfil
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'perfiles/'+this.objPerfil.IdPerfil,
					this.objPerfil
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "perfiles/"+this.objPerfil.IdPerfil
            ).then((res) => {
                this.objPerfil = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objPerfil.Fecha.replace(/-/g,'\/');
                this.objPerfil.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objPerfil = {
				IdPerfil: 0,
				Nombre: '',
				isDefault: 0,
				TipoPerfil: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

            console.log(this.Ocultar + 's')

            let user = JSON.parse(sessionStorage.getItem('user'));

            this.Ocultar = false;
            if(user.IdEmpresa == 0){
                this.Ocultar = true;
            }

            console.log(this.Ocultar + 'b')
                
            if (Id!='') 
            {
                this.objPerfil.IdPerfil = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
